import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import classNames from "classnames";
import { GrBox } from "../layout/GrBox";
/** @deprecated use GrProgress instead (duplicated component) */
export function GrLoading(props) {
    const { size, className } = props;
    return (_jsx(GrBox, { className: classNames("GrLoading", className), style: { width: size, height: size }, children: _jsx(CircularProgress, { size: size, color: "inherit" }) }));
}
//# sourceMappingURL=GrLoading.js.map